import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const SendaiCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      })}
    >
      <Heading>
        {t("せんだい生活応援！！ ポイントキャンペーンの実施について")}
      </Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "仙台市では物価高騰対策の一つとして、ポケットサインをインストールしている仙台市民の皆様に3,000ポイントをプレゼントするキャンペーンを実施しています。",
        )}
        <br />
        <br />
        {t(
          "「応募する」ボタンからポイントを受け取っていただくと、ただちにポイントが付与され、対象店舗で1ポイント＝1円として使用（使用期限は令和8年12月31日まで）できます。キャンペーンは令和8年6月30日までですので、お忘れなくお受け取りください。",
        )}
      </p>

      <Heading>{t("応募の方法")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("①「準備ボタン」を押します。")}
        <br />
        {t("②マイナンバーカードをスマートフォンにタッチします。")}
        <br />
        {t("（1日以内にカードをタッチした方などは①②が省略されます）")}
        <br />
        {t("③「応募ボタン」を押します。")}
        <br />
        {t("④ポイントが付与されます。")}
      </p>

      <Heading>{t("スケジュール")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("■ポイント受取期限")}
        <br />
        {t("令和8年6月30日まで")}
      </p>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
          mt: "12px",
        })}
      >
        {t("■ポイント使用期限")}
        <br />
        {t("令和8年12月31日まで")}
        <br />
        {t("（令和9年1月1日となった時点でポイントが失効します）")}
      </p>

      <Heading>{t("ご注意事項")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("・対象者はポイントを応募する時点で仙台市に住民登録のある方です。")}
        <br />
        {t("・抽選ではありません。")}
        <br />
        {t(
          "・ポイント付与実績を管理するため、応募いただいた方の住所、氏名、生年月日、性別を宮城県から仙台市に提供する場合があります。ご了承の上で応募いただくようお願いいたします。",
        )}
        <br />
        <br />
        {t(
          "※本キャンペーンは国の「重点支援地方交付金」を活用した事業により実施されるものです。",
        )}
      </p>
    </div>
  );
};
